import "./style/footer_style.css";

const FooterComponent = () => {
    return (
        <div className="footer-text text-center 
                    h-4rem
                    text-sm sm:text-sm md:text-sm lg:text-lg xl:text-lg
                    w-full 
                    flex flex-row 
                    align-items-center 
                    justify-content-center">
            2025 ErotiX AI. All Rights Reserved.
        </div>
    );
}

export default FooterComponent;